// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

// Soft UI Dashboard PRO React base styles
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";
import borders from "assets/theme/base/borders";

import { THEME_TYPES } from "constants/theme";
import { useSelector } from "react-redux";

function DataTableBodyCell({
  noBorder = false,
  align = "left",
  children,
  cell,
  style = {},
  stayVisible,
}) {
  const { light } = colors;
  const { size } = typography;
  const { borderWidth } = borders;
  const { width, originalWidth } = cell?.column ?? {};
  const isDark = useSelector((store) => store?.portal?.settings.themeMode) === THEME_TYPES.DARK;

  const handleWidth = () => {
    if (window.location.pathname === "/analytics/logs") {
      return width;
    } else {
      return width !== originalWidth ? width : "auto";
    }
  };

  return (
    <SoftBox
      component="td"
      textAlign={align}
      fontSize={size.sm}
      borderBottom={noBorder ? "none" : `${borderWidth[1]} solid ${isDark ? colors.dark.main : light.main}`}
      py={1.5}
      px={3}
      style={{ ...style }}
    >
      <SoftBox
        display="inline-block"
        width={handleWidth()}
        color="text"
        whiteSpace={"pre"}
        sx={{
          textOverflow: "ellipsis",
          overflow: stayVisible ? "visible" : "hidden",
          whiteSpace:
            cell.column.Header === "Step" || cell.column.Header === "Error message"
              ? "nowrap"
              : "pre",
        }}
      >
        {children}
      </SoftBox>
    </SoftBox>
  );
}

// Typechecking props for the DataTableBodyCell
DataTableBodyCell.propTypes = {
  children: PropTypes.node,
  noBorder: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right", "center"]),
};

export default DataTableBodyCell;
